import React from 'react';
import styles from './index.module.less';
import { useTranslation } from '@/modules/ReoI18n';
import { getOfficialSitePath } from '@/utils/function/sitePath';
const CompFourNoIdeas: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className={ `${styles['four-no-ideas']} text-center` }>
            <span className={ styles['four-no-ideas-title'] }>{t('page-not-found:have-no-ideas')}</span>
            <a
                href={ getOfficialSitePath('/solution-finder/') }
                className={ styles['find-solution'] }>
                {t('page-not-found:find-a-solution')}
            </a>
            <a
                href={ getOfficialSitePath('/contact-us/') }
                className={ styles['contact-us'] }>
                {t('page-not-found:contact-support')}
            </a>
        </div>
    );
};
export default CompFourNoIdeas;
